module.exports = __webpack_public_path__ + "img/image-two.12f985b4.jpg";